// extracted by mini-css-extract-plugin
export default {"card":"IQ","cardrow":"JQ","cardcentered":"KQ","details":"LQ","imgwrapper":"MQ","img":"NQ","category":"OQ","name":"PQ","copy":"QQ","detailsbtn":"RQ","remove":"SQ","price":"TQ","netPrice":"UQ","regularPrice":"VQ","label":"WQ"};
    if(module.hot) {
      // 1715091680643
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  